export default __webpack_public_path__ + "static/media/imgFive.f8ebcbf5.jpg";